import { buttonLabels } from './constants';
import { UtilityService } from "../../services/UtilityService";

export const TierPriceValidator = (price: any) => {
    if (!price) return 'Required*';
    return '';
};

export const emailValidator = (email: string) => {
    if (!email || email.length <= 0) return 'Email cannot be blank';
    if (!!email && !UtilityService.isValidEmail(email)) return 'Invalid Email';
    if (!!email) {
        return UtilityService.validateEmailLength(email)
    }
    return '';
};

export const contactEmailValidator = (email: string) => {
    if (!!email && !UtilityService.isValidEmail(email)) return 'Invalid Email';
    if (!!email) {
        return UtilityService.validateEmailLength(email)
    }
    return '';
};

export const currentpasswordValidator = (password: string) => {
    if (!password || password.length <= 0) return 'Current Password cannot be blank';
    return '';
};

export const passwordValidator = (password: string) => {
    if (!password || password.length <= 0) return 'Password cannot be blank';
    return '';
};

export const confirmPasswordValidator = (passwords: any): string => {

    if (typeof passwords === "object") {
        if (passwords.newPassword && passwords.confirmPassword && passwords.newPassword !== passwords.confirmPassword) {
            return 'Passwords do not match';
        }
    }
    else if (typeof passwords === "string") {
        if (!passwords || passwords.length <= 0) return 'Enter Confirm Password';
    }
    return '';
};

export const newPasswordValidator = (passwords: any): string => {
    if (typeof passwords === "object") {
        let { newPassword } = passwords;
        if (!newPassword || newPassword.length <= 0) return 'Enter Password';
        if (!!newPassword && !UtilityService.validatePassword(newPassword)) return 'Password does not meet requirements'
        return '';
    }
    else if (typeof passwords === "string") {
        if (!passwords || passwords.length <= 0) return 'Enter Password';
        if (!!passwords && !UtilityService.validatePassword(passwords)) return 'Password does not meet requirements'
    }
    return '';
};

export const titleValidator = (name: string) => {
    name = name.trim();
    if (!name || name.length <= 0)
        return `Title cannot be blank`;
    else if (name.length > 50)
        return `Title should not exceed 50 characters`;
    else return '';
};
export const descriptionValidator = (description: string) => {
    if (!description || description.length <= 0)
        return `Description cannot be blank`;
    else return '';
};

export const nameValidator = (name: string) => {
    // name = name.trim();
    if (!name || name.length <= 0)
        return `Name cannot be blank`;
    else if (name.length > 30)
        return `Name should not exceed 30 characters`;
    else return '';
};

export const GroupNameValidator = (name: string) => {
    if (!name || name.length <= 0)
        return `Group Name cannot be blank`;
    else if (name.length > 30)
        return `Group Name should not exceed 30 characters`;
    else return '';
};
export const GroupChatNameValidator = (name: string) => {

    if (!name || name.length <= 0)
        return `Group Chat Name cannot be blank`;
    else if (name.length > 30)
        return `Group Chat Name should not exceed 30 characters`;
    else return '';
};
export const firstNameValidator = (name: string) => {
    name = name?.trim();
    if (!name || name.length <= 0)
        return `First Name cannot be blank`;
    else if (name.length > 30)
        return `First Name should not exceed 30 characters`;
    else return '';
};

export const PhoneFirstNameValidator = (name: string) => {
    name = name.trim();
    if (!name || name.length <= 0)
        return `First Name cannot be blank`;
    else if (name.length > 20)
        return `First Name should not exceed 20 characters`;
    else return '';
}

export const lastNameValidator = (name: string) => {
    name = name?.trim();
    if (!name || name.length <= 0)
        return `Last Name cannot be blank`;
    else if (name.length > 30)
        return `Last Name should not exceed 30 characters`;
    else return '';
};

export const PhoneLastNameValidator = (name: string) => {
    name = name.trim();
    if (!name || name.length <= 0)
        return `Last Name cannot be blank`;
    else if (name.length > 20)
        return `Last Name should not exceed 20 characters`;
    else return '';
};

export const contactLastNameValidator = (name: string) => {
    if (name && name.length > 30)
        return `Last Name should not exceed 30 characters`;
    else return '';
};

export const OrgNameValidator = (org: string) => {
    if (!org || org.length <= 0)
        return `Organization name cannot be blank`;
    else if (org.length > 30)
        return `Organization name should not exceed 30 characters`;
    else return '';
};

export const AddressValidator = (address: string) => {
    if (!address || address.length <= 0)
        return `Address cannot be blank`;
    else return '';
};

export const StateValidator = (state: string) => {
    if (!state || state.length <= 0)
        return `State cannot be blank`;
    else return '';
};

export const CountryValidator = (country: string) => {
    if (!country || country.length <= 0)
        return `Country cannot be blank`;
    else return '';
};

export const UserNameValidator = (username: string) => {
    if (!username || username.length <= 0)
        return `User Name cannot be blank`;
    else return "";
}

export const PhoneNumberValidator = (phoneNumber: string) => {
    if (!phoneNumber || phoneNumber.match(/\d+/g) === null) {
        return "Phone Number cannot be blank";
    }
    if (!!phoneNumber && !UtilityService.validPhoneNumber(phoneNumber)) {
        return "Invalid Phone Number";
    }

    else if (!!phoneNumber && UtilityService.validPhoneNumber(phoneNumber)) {
        return "";
    }
    else return "";
}

export const MobileNumberValidator = (phoneNumber: string) => {
    phoneNumber = phoneNumber.replace(/[^0-9]/g, "")
    if (!phoneNumber) {
        return "Mobile Number cannot be blank";
    }

    else if (!!phoneNumber && phoneNumber.replace(/[^\d]/g, "").length < 11 && phoneNumber.replace(/[^\d]/g, "").length > 0) {
        return "Invalid Mobile Number";
    }

    else if (!!phoneNumber && phoneNumber.replace(/[^\d]/g, "").length === 11) {
        return "";
    }
    else return "";
}

export const zipcodeValidator = (zipcode: string) => {
    const zip = /^\d{4,6}/;
    if (!zipcode || zipcode.length <= 0) return 'Zipcode cannot be blank';
    // if (!!zipcode && !zip.test(zipcode)) return 'Invalid Zipcode';
    return '';
};

export const CityValidator = (city: string) => {
    const cityEx = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/
    if (!city || city.length <= 0) return 'City cannot be blank';
    if (!!city && !cityEx.test(city)) return 'Invalid city name';
    return "";
}

export const RoleValidator = (role: number) => {
    if (role === -1) {
        return "Role cannot be blank";
    }
    return "";
}

export const OrgIDValidator = (orgID: string) => {
    if (!orgID) {
        return "Organization cannot be blank";
    }
    return "";
}
export const PhoneIDValidator = (phoneID: string) => {
    if (!phoneID) {
        return "Phone Number cannot be blank";
    }
    return "";
}
export const ProviderIDValidator = (providerID: number) => {
    if (providerID === -1) {
        return "Provider cannot be blank";
    }
    return "";
}
export const IndustryValidator = (industry: string) => {
    if (!industry) {
        return "Industry cannot be blank";
    }
    return "";
}

export const HouseNumberValidator = (housenumber: string) => {
    // housenumber = housenumber.trim();
    if (!housenumber || housenumber.length <= 0)
        return `House number cannot be blank`;
    else return "";
}

export const StreetNameValidator = (streetname: string) => {
    streetname = streetname.trim();
    if (!streetname || streetname.length <= 0)
        return `Street name cannot be blank`;
    else return "";
}

export const BugReportValidator = (bugreport: string) => {
    if (!bugreport || bugreport.length <= 0)
        return `Bug Report cannot be blank`;
    else return "";
}
export const CategoryValidator = (selectcategory: string) => {
    if (!selectcategory || selectcategory.length <= 0)
        return `Select Categoery cannot be blank`;
    else return "";
}

export const TypeValidator = (type: number) => {
    if (type === -1) {
        return "Type cannot be blank";
    }
    return "";
}

export const TitleValidator = (title: string) => {
    if (!title || title.length <= 0)
        return `Title cannot be blank`;

    else return '';
};

export const SubtitleValidator = (subtitle: string) => {
    if (!subtitle || subtitle.length <= 0)
        return `Subtitle cannot be blank`;

    else return '';
};

export const LinkTypeValidator = (linktype: number) => {
    if (linktype === 0) {
        return "Link Type cannot be blank";
    }
    return "";
};
export const DisplyTextValidator = (displytext: string) => {
    if (!displytext || displytext.length <= 0)
        return `Display Text cannot be blank`;

    else return '';
}
export const KeywordValidator = (name: string) => {
    const keyword = /^\S+$/;
    if (!name || name.length <= 0)
        return `Keyword cannot be blank`;
    else if (name.length > 30)
        return `Keyword should not exceed 30 characters`;
    else if (!!name && !keyword.test(name))
        return 'Invalid Keyword';
    else if (name.toLowerCase() === buttonLabels.STOP.toLowerCase() || name.toLowerCase() === buttonLabels.UNSTOP.toLowerCase() || name.toLowerCase() === buttonLabels.HELP.toLowerCase())
        return 'You cannot use STOP/UNSTOP/HELP as a keyword';
    else return '';
};

export const DurationTypeValidator = (durationtype: number) => {
    if (durationtype === -1) {
        return "Duration Type cannot be blank";
    }
    return "";
}

export const DaysValidator = (days: any) => {
    if (days.length <= 0) {
        return "Days cannot be blank";
    }
    return "";
}
export const referenceValidator = (reference: string) => {
    var regex = /[^A-Za-z0-9]/;
    if (!reference || reference.length <= 0) return 'Reference cannot be blank';
    if (!!reference && regex.test(String(reference).toLowerCase())) return 'Special Characters are not allowed';
    if (reference.length > 10) return `Reference should not exceed 10 characters`;
    return '';
};

export const resetpasswordValidator = (password: string) => {
    if (!password || password.length <= 0) return 'Password cannot be blank';
    if (!!password && !UtilityService.validatePassword(password)) return 'Password does not meet requirements'
    return '';
};

export const KeywordIDValidator = (keywordID: string) => {
    if (!keywordID) {
        return "Keyword cannot be blank";
    }
    return "";
}

export const MessageValidator = (message: string) => {
    message = message.trim();
    if (!message) {
        return "Message cannot be blank";
    }
    return "";
}
export const confirmNewPasswordValidator = (passwords: any): string => {
    if (typeof passwords === "object") {
        if (passwords.newPassword && passwords.confirmPassword && passwords.newPassword !== passwords.confirmPassword) {
            return 'Passwords do not match';
        }
    }
    else if (typeof passwords === "string") {
        if (!passwords || passwords.length <= 0) return 'Enter Confirm Password';
    }
}
export const alertLinkValidator = (link: string) => {
    if (!link || link.length <= 0)
        return `Link cannot be blank`;
    if (!!link && !UtilityService.isValidURL(link)) return 'Incorrect URL';
    return '';
};

export const startTimeValidator = (time: number) => {
    if (time === -1) {
        return `Time cannot be blank`;
    }
}

export const UploadFileValidator = (fileUpload) => {
    if (!fileUpload) {
        return "Atleast select one file"
    }
}
export const AddAccessValidator = (addaccesslist) => {
    if (addaccesslist?.length < 1) {
        return "Enter the email addresses that should be given access to the file"
    }
    else {
        let valid = addaccesslist?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !x)
        return valid?.length > 0 && "Invalid email"
    }
}

export const SelectProductValidator = (product) => {
    if (product === undefined) {
        return "Select Product Cannot be blank"
    }
}

export const stringlengthValidator = (name: string, value: string, count: number) => {

    if (!!value) {
        return value.length > count ? `${name} should not exceed ${count} characters` : ``
    }
    else {
        return `${name} cannot be blank`
    }

}

const Validator: { [key: string]: (value: string | any) => string } = {
    "name": nameValidator,
    "firstname": firstNameValidator,
    "email": emailValidator,
    "contactemail": contactEmailValidator,
    "currentpassword": currentpasswordValidator,
    "phonenumber": PhoneNumberValidator,
    "mobilenumber": MobileNumberValidator,
    "organization": OrgNameValidator,
    "zipcode": zipcodeValidator,
    "city": CityValidator,
    "address": AddressValidator,
    "state": StateValidator,
    "newgroupname": GroupNameValidator,
    "groupchatname": GroupChatNameValidator,
    "lastname": lastNameValidator,
    "contactlastname": contactLastNameValidator,
    "username": UserNameValidator,
    "price": TierPriceValidator,
    "yearlyprice": TierPriceValidator,
    "password": passwordValidator,
    "newpassword": newPasswordValidator,
    "confirmpassword": confirmPasswordValidator,
    "title": titleValidator,
    "role": RoleValidator,
    "organizationid": OrgIDValidator,
    "phonenumberid": PhoneIDValidator,
    "providerid": ProviderIDValidator,
    "industry": IndustryValidator,
    "description": descriptionValidator,
    "housenumber": HouseNumberValidator,
    "streetname": StreetNameValidator,
    "selectcategory": CategoryValidator,
    "bugreport": BugReportValidator,
    "country": CountryValidator,
    "type": TypeValidator,
    "subtitle": SubtitleValidator,
    "linktype": LinkTypeValidator,
    "displytext": DisplyTextValidator,
    "keyword": KeywordValidator,
    "durationtype": DurationTypeValidator,
    "days": DaysValidator,
    "reference": referenceValidator,
    "resetnewpassword": resetpasswordValidator,
    "keywordid": KeywordIDValidator,
    "confirmnewpassword": confirmNewPasswordValidator,
    "link": alertLinkValidator,
    "starttime": startTimeValidator,
    "endtime": startTimeValidator,
    "message": MessageValidator,
    "phonefirstname": PhoneFirstNameValidator,
    "phonelastname": PhoneLastNameValidator,
    "fileupload": UploadFileValidator,
    "emailaccess": AddAccessValidator,
    "selectproduct": SelectProductValidator,
}

export default Validator;

export const validateForm = (data: any, errorCallback: (errors: { [key: string]: string }) => void) => {
    let isValid = true;
    let errors: { [key: string]: string } = {};
    Object.keys(data).forEach((key) => {
        if (key && Validator[key.toLowerCase()]) {
            let value = data[key];
            value = typeof value === "string" ? value.trim() : value;
            let error = Validator[key.toLowerCase()](value);

            errors[key] = error;
            isValid = isValid && !error;
        }
    });
    errorCallback(errors)
    return isValid;
};